import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import RedirectLink from '../models/RedirectLink';
import Urls from './../api/Urls';

export function getRedirectLink(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.REDIRECT_LINK_LIST,
        params: params,
        parser: redirectLinkDataParser,
    }).get();
}

export function getRedirectLinkDetail(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.REDIRECT_LINK_DETAIL,
        endpointParams: { id },
        parser: (data) => new RedirectLink(data.data),
    }).get();
}

export function createRedirectLinkDetail(redirectLink) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.REDIRECT_LINK_ACTION,
        parser: (data) => new RedirectLink(data.redirectLink),
    }).post(redirectLink.export());
}

export function updateRedirectLinkDetail(redirectLink) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.REDIRECT_LINK_ACTION,
        parser: (data) => new RedirectLink(data.redirectLink),
    }).put(redirectLink.export());
}

export function deleteRedirectLinkDetail(redirectLink) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.REDIRECT_LINK_DETAIL,
        endpointParams: { id: redirectLink.id }
    }).delete();
}

const redirectLinkDataParser = (data) => ({
    result: (data.data.result || []).map(item => new RedirectLink(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})